import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

// init Swiper:
const swiper = new Swiper('.image-copy-carousel-container', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    // fade
    effect: "fade",
    autoplay: {
        delay: 4000,
    },
    loop: true,
    // autoHeigh
    autoHeight: true,
    fadeEffect: { crossFade: true },
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev'
    // }
});
